import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { loadAllAgent } from "@/redux/rtk/features/CRM/agent/agentSlice";
import { loadAllUniversity } from "@/redux/rtk/features/CRM/university/universitySlice";
import { useGetLeadSourcesQuery } from "@/redux/rtk/features/leadSource/leadSourceApi";
import { useGetMajorsQuery } from "@/redux/rtk/features/major/majorApi";
import { useTranslation } from "react-i18next";

export default function useApplicationFilter(enabled = false, isAgent = false) {
    const { t } = useTranslation();
    const agent = useSelector((state) => state.agent.list) || [];
    const university = useSelector((state) => state.university.list) || [];
    const { data: leadSources } = useGetLeadSourcesQuery(undefined, { skip: !enabled });
    const { data: majors } = useGetMajorsQuery(undefined, { skip: !enabled });
    const dispatch = useDispatch();

    useEffect(() => {
        if (enabled) {
            dispatch(loadAllAgent());
            dispatch(loadAllUniversity());
        }
    }, [dispatch, enabled]);

    const filter = [
        {
            key: "agentId",
            label: t("common.filterLabels.agent"),
            type: "select",
            options: agent?.map((item) => ({
                label: item.firstName ? `${item.firstName} ${item.lastName}` : item.companyName,
                value: item.id,
            })),
            className: "min-w-[100px] max-w-[150px]",
            popupClassName: "w-[150px]",
        },
        {
            key: "universityId",
            label: t("common.filterLabels.university"),
            type: "select",
            options: university?.map((item) => ({
                label: item.universityName || item.name,
                value: item.id,
            })),
            className: "min-w-[100px] max-w-[150px]",
            popupClassName: "w-[150px]",
        },
        {
            key: "majorId",
            label: t("common.filterLabels.major"),
            type: "select",
            options: majors?.map((item) => ({
                label: item.name,
                value: item.id,
            })),
            className: "min-w-[100px] max-w-[150px]",
            popupClassName: "w-[150px]",
        },
        {
            key: "leadSourceId",
            label: t("common.filterLabels.leadSource"),
            type: "select",
            options: leadSources?.map((item) => ({
                label: item.name,
                value: item.id,
            })),
            className: "min-w-[100px] max-w-[150px]",
            popupClassName: "w-[150px]",
        },
        {
            key: "status",
            label: t("common.filterLabels.status"),
            type: "select",
            options: [
                { label: "Submitted", value: "Submitted" },
                { label: "Similar", value: "Similar" },
                { label: "Reject", value: "Reject" },
                { label: "Miss Document", value: "Miss Document" },
                { label: "Cal", value: "Cal" },
                { label: "Pending", value: "pending" },
            ],
            className: "min-w-[85px] max-w-[150px]",
            popupClassName: "w-[150px]",
        },
        {
            key: "paymentStatus",
            label: t("common.filterLabels.paymentStatus"),
            type: "select",
            options: [
                { label: "Through", value: "through" },
                { label: "Normal", value: "normal" },
                { label: "Pending", value: "pending" },
                { label: "Failed", value: "failed" },
            ],
            className: "min-w-[100px] max-w-[150px]",
            popupClassName: "w-[150px]",
        },
        {
            key: "language",
            label: t("common.filterLabels.language"),
            type: "select",
            options: [
                { label: "AR", value: "ar" },
                { label: "EN", value: "en" },
                { label: "TR", value: "tr" },
            ],
            className: "min-w-[85px] max-w-[150px]",
        },
        {
            key: "amountRange",
            label: t("common.filterLabels.amount"),
            type: "range",
        },
        {
            key: "dateRange",
            label: t("common.filterLabels.createdDate"),
            type: "dateRange",
        }
    ];

    if (isAgent) {
        return filter.filter((f) => f.key !== "agentId");
    }

    return filter || [];
}
